import axios from 'axios';
import { useDevConsoleStore, genId } from '../store/devConsoleStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api/v1',
  timeout: 30000,
  withCredentials: true,  // send cookie on same-domain requests
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const id = genId();
  (config as any).__devConsoleId = id;
  (config as any).__devConsoleStart = Date.now();

  useDevConsoleStore.getState().addNetworkEntry({
    id,
    method: (config.method || 'GET').toUpperCase(),
    url: (config.baseURL || '') + (config.url || ''),
    requestBody: config.data,
    timestamp: Date.now(),
  });

  return config;
});

api.interceptors.response.use(
  (response) => {
    const id = (response.config as any).__devConsoleId;
    const start = (response.config as any).__devConsoleStart;
    if (id) {
      useDevConsoleStore.getState().updateNetworkEntry(id, {
        status: response.status,
        duration: Date.now() - start,
        responseBody: response.data,
      });
    }
    return response.data;
  },
  (error) => {
    const config = error.config || {};
    const id = config.__devConsoleId;
    const start = config.__devConsoleStart;
    if (id) {
      useDevConsoleStore.getState().updateNetworkEntry(id, {
        status: error.response?.status,
        duration: start ? Date.now() - start : undefined,
        responseBody: error.response?.data,
        error: error.message,
      });
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
